export default "/images/vendor/blueimp-gallery/play-pause.png?20d7213b6d7d72174e131d3643849529";